import React from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import I18n from '../../../config/i18n';
import { getBookingConfirmationPath } from '../../../routes/config';
import overviewFieldsets from '../static/fieldsets-overview';
import BookingFormLayout from './BookingFormLayout';

const BookingOverview = (props) => {
  const { handleSubmit, control } = useForm();

  return (
    <BookingFormLayout
      action={getBookingConfirmationPath()}
      title={I18n.t('booking.review')}
      fieldsets={overviewFieldsets()}
      {...props}
      handleSubmit={handleSubmit}
      control={control}
    />
  );
};

BookingOverview.propTypes = {
  /* eslint-disable react/no-unused-prop-types */
  duration_of_stay: PropTypes.number,
  number_of_adults: PropTypes.number,
  number_of_children: PropTypes.number,
  number_of_infants: PropTypes.number,
  number_of_pets: PropTypes.number,
  is_holiday_home: PropTypes.bool,
  renter: PropTypes.shape({
    name: PropTypes.string,
    street: PropTypes.string,
    invoice_postal_code: PropTypes.string,
    invoice_city: PropTypes.string,
    invoice_phone: PropTypes.string,
    invoice_mobile_phone: PropTypes.string,
    email: PropTypes.string,
  }),
  /* eslint-enable react/no-unused-prop-types */
};

export default BookingOverview;
